import { ConfirmationModalComponent } from '@app/shared/modals/confirmation-modal/confirmation-modal.component';
import { Observable, of, tap } from 'rxjs';
import { SiteSkillApiModel } from '@app/api/api-models';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { mergeMap } from 'rxjs/operators';
import { MigrationStatusEnum } from '@app/shared/enums/migration-status.enum';
import { Injectable } from '@angular/core';
import { CustomToastersService } from '@app/shared/services/custom-toasters.service';
import { CallTypesService } from '@app/api/api-services/site-settings/call-types.service';
import { MigrationRequestEnum } from '@app/shared/enums/migration-request.enum';
import { AlertClassEnum } from '@app/shared/enums/alert-class.enum';
import { SkillsMigrateStatus } from '@app/api/api-models/site-settings/site-call-types/SkillsMigrateStatus';
import { SiteSkillsMigrateRequest } from '@app/api/api-models/site-settings/site-call-types/SiteSkillsMigrateRequest';

@Injectable()
export class CallTypeMigrationService {
  public modalRef: BsModalRef;

  constructor(
    private readonly callTypeService: CallTypesService,
    private readonly bsModalService: BsModalService,
    private readonly customToasters: CustomToastersService
  ) {}

  public migrationCheck(): Observable<SkillsMigrateStatus> {
    return this.callTypeService.getMigrationStatus().pipe(
      mergeMap((response) => {
        switch (response.Status) {
          case MigrationStatusEnum.Initiated: {
            this.displayStatus();
            return of(response);
          }
          default: {
            return of(response);
          }
        }
      })
    );
  }

  public processMigration(items: SiteSkillApiModel[], migrateSome?: boolean): Observable<any> {
    return this.migrationInit(items).pipe(
      mergeMap((res) => {
        let ids = [];
        const status = !res
          ? MigrationRequestEnum.MigrateNone
          : migrateSome
          ? MigrationRequestEnum.MigrateSome
          : MigrationRequestEnum.MigrateAll;
        if (migrateSome && res) ids = items.map((item) => item.Id);
        return this.proceedMigrate(status, ids);
      })
    );
  }

  public migrationInit(items: SiteSkillApiModel[]): Observable<boolean> {
    const callTypeList = items.map((x) => `<li>${x.Name}</li>`).join('');
    const infoContent = `We have detected the following skills that should be call types: </br> <ul>${callTypeList}</ul>
 </br> Would you like to convert these skills to call types?`;

    const initialState = {
      title: 'Migration to Call Types',
      textHtml: infoContent,
      closeText: 'Cancel',
      confirmText: 'Migrate to Call types',
      alertText: `This process may take from couple minutes to an hour.
       During the time the users won't able to work with Skills in Tasks and Observation forms.`,
      alertStyle: AlertClassEnum.AlertWarning
    };

    this.modalRef = this.bsModalService.show(ConfirmationModalComponent, {
      initialState,
      backdrop: 'static'
    });
    return this.modalRef.content.confirmation;
  }

  private displayStatus(): void {
    const infoContent = `Please check back later when this process is complete. This may take from several minutes to an hour depending on the database size.`;
    const infoTitle = 'Call Types Migration Process is Underway';
    this.customToasters.clear();
    this.customToasters.alertInfo(infoContent, infoTitle);
  }

  private proceedMigrate(status: MigrationRequestEnum, ids: number[]): Observable<SkillsMigrateStatus> {
    const req = new SiteSkillsMigrateRequest();
    req.ids = ids;
    req.initiate = status;

    this.customToasters.waitProcessing();
    return this.callTypeService.migrateCallTypes(req).pipe(
      tap((res) => {
        if (res.Status === MigrationStatusEnum.Initiated) this.displayStatus();
      })
    );
  }
}
